// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { Link } from 'react-router-dom';

// const templates = [
//     { name: 'eMedha Chatbot Services_team (en)', preview: 'Say Hello! to eMedha Chatbot Services 👋', status: 'APPROVED', created: '10 Apr, 2024', modified: '10 Apr, 2024' },
//     { name: 'test_character_limit_templat...', preview: 'Contrary to popular belief, L...', status: 'APPROVED', created: '29 Mar, 2024', modified: '29 Mar, 2024' },
//     { name: 'text_template_011_new_011...', preview: 'Hello {{1}}, Thank you for sh...', status: 'APPROVED', created: '12 Feb, 2024', modified: '12 Feb, 2024' },
//     { name: 'lto_02_copy_new', preview: 'Honest feedbacks from som...', status: 'APPROVED', created: '12 Feb, 2024', modified: '12 Feb, 2024' },
//     { name: 'update_lto02_copy', preview: 'Check here!!!', status: 'APPROVED', created: '12 Feb, 2024', modified: '12 Feb, 2024' }
// ];

// const MessageTemplates = () => {
//     return (
//         <div className="container mt-4">
//             <h3>Message Templates</h3>
//             <div className="d-flex mb-3 gap-2">
//              <Link to='/add-templates'>  <button className="btn btn-success">Add New</button></Link> 
//                 <button className="btn btn-outline-primary">Fetch Templates</button>
//                 <button className="btn btn-outline-secondary">Refresh Statuses</button>
//                 <input type="text" className="form-control w-25 ms-auto" placeholder="Search..." />
//             </div>
//             <table className="table table-striped table-hover">
//                 <thead>
//                     <tr>
//                         <th>TEMPLATE NAME</th>
//                         <th>PREVIEW</th>
//                         <th>STATUS</th>
//                         <th>CREATED</th>
//                         <th>LAST MODIFIED</th>
//                         <th>ACTIONS</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {templates.map((template, index) => (
//                         <tr key={index}>
//                             <td>{template.name}</td>
//                             <td>{template.preview}</td>
//                             <td>
//                                 <span className="badge bg-success">{template.status}</span>
//                             </td>
//                             <td>{template.created}</td>
//                             <td>{template.modified}</td>
//                             <td>
//                                 <i className="fas fa-chart-line me-2"></i>
//                                 <i className="fas fa-edit me-2"></i>
//                                 <i className="fas fa-trash-alt"></i>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//             <div className="d-flex justify-content-between align-items-center">
//                 <span>Showing 1 to 5 of 89 entries</span>
//                 <nav>
//                     <ul className="pagination mb-0">
//                         <li className="page-item"><a className="page-link" href="#">Previous</a></li>
//                         <li className="page-item active"><a className="page-link" href="#">1</a></li>
//                         <li className="page-item"><a className="page-link" href="#">2</a></li>
//                         <li className="page-item"><a className="page-link" href="#">3</a></li>
//                         <li className="page-item"><a className="page-link" href="#">Next</a></li>
//                     </ul>
//                 </nav>
//             </div>
//         </div>
//     );
// };

// export default MessageTemplates;




// -------------------- Rahul Verma open-----------------//

// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useNavigate } from 'react-router-dom';
// import { FaEye } from 'react-icons/fa';

// const MessageTemplates = () => {
//     const [templates, setTemplates] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [templatesPerPage] = useState(10);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [wid, setWid] = useState(null);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const user = JSON.parse(sessionStorage.getItem('user'));
//         if (!user ) return;

//   // ROLE-BASED EMAIL
//   const emailToUse =
//     user.role === "admin"
//       ? user.email   // Admin → use own email
//       : user.adminEmail; // Member → use adminEmail

//   console.log("API Email Used:", emailToUse);

//   if (!emailToUse) return;

//         fetch(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//             .then(res => res.json())
//             .then(data => {
//                 if (data.wa_id) {
//                     setWid(data.wa_id);
//                 } else {
//                     console.warn("wa_id not found for user");
//                 }
//             })
//             .catch(err => console.error("Error fetching user data:", err));
//     }, []);

//     useEffect(() => {
//         if (wid) {
//             fetchTemplates(wid);
//         }
//     }, [wid]);

//     const fetchTemplates = async (waId) => {
//         try {
//             const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=10&wid=${waId}`);
//             const data = await response.json();
//             if (data && data.data) {
//                 setTemplates(data.data);
//             }
//         } catch (error) {
//             console.error("Error fetching templates:", error);
//         }
//     };

//     const handleRefreshStatuses = () => {
//         if (wid) {
//             fetchTemplates(wid); 
//         }
//     };

//     const filteredTemplates = templates.filter(template =>
//         template.name.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     const indexOfLastTemplate = currentPage * templatesPerPage;
//     const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
//     const currentTemplates = filteredTemplates.slice(indexOfFirstTemplate, indexOfLastTemplate);

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     const handleViewTemplateDetails = async (templateName) => {
//         try {
//             const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateInfo.php?name=${templateName}&wid=${wid}`);
//             const data = await response.json();
//             if (data && data.data && data.data.length > 0) {
//                 const templateDetails = data.data[0];
//                 navigate('/message-temp-view', { state: { templateDetails } });
//             } else {
//                 console.log("No details found for this template");
//             }
//         } catch (error) {
//             console.error("Error fetching template details:", error);
//         }
//     };

//     return (
//         <div className="container mt-4">
//             <h3>Message Templates</h3>
//             <div className="d-flex mb-3 gap-2">
//                 <button className="btn btn-outline-primary btn-sm" onClick={handleRefreshStatuses}>Fetch Templates</button>
//                 <button className="btn btn-outline-secondary btn-sm" onClick={handleRefreshStatuses}>Refresh Statuses</button>
//                 <input type="text" className="form-control w-25 ms-auto" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
//             </div>
//             <table className="table table-striped table-hover table-bordered">
//                 <thead className="table table-dark">
//                     <tr>
//                         <th>TEMPLATE NAME</th>
//                         <th>STATUS</th>
//                         <th>ACTIONS</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {currentTemplates.map((template, index) => (
//                         <tr key={index}>
//                             <td>{template.name}</td>
//                             <td>
//                                 <span className={`badge ${template.status === 'REJECTED' ? 'bg-danger' : 'bg-success'}`} style={template.status === 'REJECTED' ? { color: 'white' } : {}}>
//                                     {template.status}
//                                 </span>
//                             </td>
//                             <td><FaEye style={{ cursor: "pointer" }} onClick={() => handleViewTemplateDetails(template.name)} /></td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>

//             <div className="d-flex justify-content-between align-items-center">
//                 <span>Showing {indexOfFirstTemplate + 1} to {Math.min(indexOfLastTemplate, filteredTemplates.length)} of {filteredTemplates.length} entries</span>
//                 <nav>
//                     <ul className="pagination mb-0">
//                         <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                             <button className="page-link btn-sm" onClick={() => paginate(currentPage - 1)}>Previous</button>
//                         </li>
//                         {[...Array(Math.ceil(filteredTemplates.length / templatesPerPage)).keys()].map((pageNumber) => (
//                             <li key={pageNumber + 1} className={`page-item ${currentPage === pageNumber + 1 ? 'active' : ''}`}>
//                                 <button className="page-link btn-sm" onClick={() => paginate(pageNumber + 1)}>{pageNumber + 1}</button>
//                             </li>
//                         ))}
//                         <li className={`page-item ${currentPage === Math.ceil(filteredTemplates.length / templatesPerPage) ? 'disabled' : ''}`}>
//                             <button className="page-link btn-sm" onClick={() => paginate(currentPage + 1)}>Next</button>
//                         </li>
//                     </ul>
//                 </nav>
//             </div>
//         </div>
//     );
// };

// export default MessageTemplates;



// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useNavigate } from 'react-router-dom';
// import { FaEye, FaSyncAlt } from 'react-icons/fa';

// const MessageTemplates = () => {
//     const [templates, setTemplates] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [templatesPerPage] = useState(5);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [wid, setWid] = useState(null);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const user = JSON.parse(sessionStorage.getItem('user'));
//         if (!user) return;

//         const emailToUse = user.role === "admin" ? user.email : user.adminEmail;

//         if (!emailToUse) return;

//         fetch(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
//             .then(res => res.json())
//             .then(data => {
//                 if (data.wa_id) {
//                     setWid(data.wa_id);
//                 } else {
//                     console.warn("wa_id not found for user");
//                 }
//             })
//             .catch(err => console.error("Error fetching user data:", err));
//     }, []);

//     useEffect(() => {
//         if (wid) {
//             fetchTemplates(wid);
//         }
//     }, [wid]);

//     const fetchTemplates = async (waId) => {
//         try {
//             const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=100&wid=${waId}`);
//             const data = await response.json();

//             if (data && data.data) {
//                 const cleanArray = Array.isArray(data.data) ? data.data : Object.values(data.data);
//                 setTemplates(cleanArray);
//             }
//         } catch (error) {
//             console.error("Error fetching templates:", error);
//         }
//     };

//     const handleRefreshStatuses = () => {
//         if (wid) {
//             fetchTemplates(wid);
//         }
//     };

//     const handleSearchChange = (e) => {
//         setSearchQuery(e.target.value);
//         setCurrentPage(1);
//     };

//     const filteredTemplates = templates.filter(template =>
//         template && template.name && template.name.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     const totalEntries = filteredTemplates.length;
//     const indexOfLastTemplate = currentPage * templatesPerPage;
//     const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
//     const currentTemplates = filteredTemplates.slice(indexOfFirstTemplate, indexOfLastTemplate);

//     const displayStart = totalEntries > 0 ? indexOfFirstTemplate + 1 : 0;
//     const displayEnd = Math.min(indexOfLastTemplate, totalEntries);

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     const handleViewTemplateDetails = async (templateName) => {
//         try {
//             const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateInfo.php?name=${templateName}&wid=${wid}`);
//             const data = await response.json();
//             if (data && data.data && data.data.length > 0) {
//                 const templateDetails = data.data[0];
//                 navigate('/message-temp-view', { state: { templateDetails } });
//             } else {
//                 console.log("No details found for this template");
//             }
//         } catch (error) {
//             console.error("Error fetching template details:", error);
//         }
//     };

//     const totalPages = Math.ceil(totalEntries / templatesPerPage);

//     // DYNAMIC PAGINATION TRUNCATION ALGORITHM (e.g., 1 2 3 ... 50)
//     const getPaginationRange = () => {
//         const totalNumbers = 5; // Total page buttons to show around current selection
//         const siblings = 1;     // Active page item siblings

//         if (totalPages <= totalNumbers + 2) {
//             return [...Array(totalPages).keys()].map(i => i + 1);
//         }

//         const leftSiblingIndex = Math.max(currentPage - siblings, 1);
//         const rightSiblingIndex = Math.min(currentPage + siblings, totalPages);

//         const showLeftEllipsis = leftSiblingIndex > 2;
//         const showRightEllipsis = rightSiblingIndex < totalPages - 1;

//         if (!showLeftEllipsis && showRightEllipsis) {
//             let leftItemCount = 3 + 2 * siblings;
//             let leftRange = [...Array(leftItemCount).keys()].map(i => i + 1);
//             return [...leftRange, '...', totalPages];
//         }

//         if (showLeftEllipsis && !showRightEllipsis) {
//             let rightItemCount = 3 + 2 * siblings;
//             let rightRange = [...Array(rightItemCount).keys()].map(i => totalPages - rightItemCount + i + 1);
//             return [1, '...', ...rightRange];
//         }

//         if (showLeftEllipsis && showRightEllipsis) {
//             let middleRange = [];
//             for (let i = leftSiblingIndex; i <= rightSiblingIndex; i++) {
//                 middleRange.push(i);
//             }
//             return [1, '...', ...middleRange, '...', totalPages];
//         }
//     };

//     const paginationRange = getPaginationRange();

//     return (
//         <div className="my-5" style={{ maxWidth: '1100px' }}>
//             {/* Header Area */}
//             <div className="d-flex justify-content-between align-items-center mb-4">
//                 <div>
//                     <h3 className="fw-bold text-dark m-0" style={{ letterSpacing: '-0.5px' }}>Message Templates</h3>
//                     <p className="text-muted small m-0">Manage and monitor your automated conversational templates</p>
//                 </div>
//                 <div className="d-flex gap-2">
//                     <button className="btn btn-light border btn-sm d-flex align-items-center gap-2 px-3 py-2 fw-medium text-secondary" onClick={handleRefreshStatuses}>
//                         <FaSyncAlt size={12} /> Sync Statuses
//                     </button>
//                 </div>
//             </div>

//             {/* Main Aesthetic Card Content Container */}
//             <div className="card border-0 shadow-sm rounded-4 p-4 bg-white">

//                 {/* Table Control Header */}
//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                     <div className="text-muted small fw-medium">
//                         Showing <span className="text-dark fw-semibold">{displayStart}</span> to <span className="text-dark fw-semibold">{displayEnd}</span> of <span className="text-dark fw-semibold">{totalEntries}</span> templates
//                     </div>
//                     <input
//                         type="text"
//                         className="form-control form-control-sm border-light-subtle bg-light rounded-3 px-3 py-2"
//                         style={{ width: '260px', fontSize: '14px' }}
//                         placeholder="Search template name..."
//                         value={searchQuery}
//                         onChange={handleSearchChange}
//                     />
//                 </div>

//                 {/* Modernized Clean Table */}
//                 <div className="table-responsive">
//                     <table className="table align-middle custom-table mb-0" style={{ fontSize: '14px' }}>
//                         <thead>
//                             <tr className="text-secondary text-uppercase fs-7 border-bottom" style={{ letterSpacing: '0.5px', fontSize: '11px' }}>
//                                 <th className="pb-3 ps-0 fw-bold" style={{ width: '55%' }}>Template Name</th>
//                                 <th className="pb-3 fw-bold" style={{ width: '25%' }}>Status</th>
//                                 <th className="pb-3 text-end pe-0 fw-bold" style={{ width: '20%' }}>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className="border-0">
//                             {currentTemplates.length > 0 ? (
//                                 currentTemplates.map((template, index) => (
//                                     <tr key={index} className="align-middle">
//                                         <td className="py-3 ps-0 fw-medium text-dark">{template?.name || "Unnamed"}</td>
//                                         <td className="py-3">
//                                             <span
//                                                 className={`badge rounded-pill px-3 py-2 fw-semibold`}
//                                                 style={{
//                                                     fontSize: '11px',
//                                                     backgroundColor: template?.status === 'APPROVED' ? '#E6F4EA' : '#FCE8E6',
//                                                     color: template?.status === 'APPROVED' ? '#137333' : '#C5221F'
//                                                 }}
//                                             >
//                                                 {template?.status || 'UNKNOWN'}
//                                             </span>
//                                         </td>
//                                         <td className="py-3 text-end pe-0">
//                                             <button
//                                                 className="btn btn-link text-secondary p-0 border-0 me-1 text-decoration-none"
//                                                 title="View Details"
//                                                 onClick={() => handleViewTemplateDetails(template.name)}
//                                             >
//                                                 <FaEye size={16} className="text-opacity-50" style={{ transition: 'color 0.2s' }} />
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="3" className="text-center py-5 text-muted">
//                                         No templates found matching your criteria.
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Clean Pagination Footer */}
//                 {totalPages > 1 && (
//                     <div className="d-flex justify-content-end align-items-center pt-4 mt-2 border-top border-light">
//                         <nav>
//                             <ul className="pagination pagination-sm mb-0 gap-1 align-items-center">
//                                 {/* Previous Button */}
//                                 <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                                     <button className="page-link border-0 rounded-3 px-3 py-2 bg-light text-dark font-medium" onClick={() => currentPage > 1 && paginate(currentPage - 1)}>
//                                         Previous
//                                     </button>
//                                 </li>

//                                 {/* Generated Dynamic Range with Ellipsis dots */}
//                                 {paginationRange.map((pageNumber, index) => {
//                                     if (pageNumber === '...') {
//                                         return (
//                                             <li key={`ellipsis-${index}`} className="page-item disabled px-2 text-muted fw-bold">
//                                                 ...
//                                             </li>
//                                         );
//                                     }

//                                     return (
//                                         <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
//                                             <button
//                                                 className="page-link border-0 rounded-3 px-3 py-2 fw-medium"
//                                                 style={{
//                                                     backgroundColor: currentPage === pageNumber ? '#0d6efd' : 'transparent',
//                                                     color: currentPage === pageNumber ? '#fff' : '#495057'
//                                                 }}
//                                                 onClick={() => paginate(pageNumber)}
//                                             >
//                                                 {pageNumber}
//                                             </button>
//                                         </li>
//                                     );
//                                 })}

//                                 {/* Next Button */}
//                                 <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                                     <button className="page-link border-0 rounded-3 px-3 py-2 bg-light text-dark font-medium" onClick={() => currentPage < totalPages && paginate(currentPage + 1)}>
//                                         Next
//                                     </button>
//                                 </li>
//                             </ul>
//                         </nav>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default MessageTemplates;


// import React, { useState } from "react";
// import {
//   MessageSquare, Plus, Search, Eye, X, ChevronLeft, ChevronRight,
//   FileText, CheckCircle, Tag, Layers, MousePointerClick,
// } from "lucide-react";

// // ─── Data ─────────────────────────────────────────────────────────────────────

// const TEMPLATES = [
//   {
//     id: "1", name: "lions_dir", status: "APPROVED", category: "MARKETING", language: "en_US",
//     components: [
//       { type: "HEADER", format: "DOCUMENT", text: "View PDF Document" },
//       {
//         type: "BODY",
//         text: "Dear {{1}}, Greetings of the day! Hope you are busy in final preparation of your glorious year and started your PST Schooling and preparation for *HONG KONG* convention to get installed as District Governor. On your return as District Governor if you wish to launch your digital directory with cabinet, clubs and members data no worries, we can do it in just 3 weeks' time. Contact me @ 9849164361 right away with your last year pdf file (directory) and this year logo, theme and team. We just do it a brand-new *Directory WITH YOUR LOGO* and push in app store and play store for your launch as soon as you land from *HONG KONG* Reach Us right now to pre-book your customized colorful digital mobile directory.. make a difference as a *LEADER.* You can do a demo signup and login in the link https://lionsdirectory.emedha.in/admin-signup Wishing you all the best! 🌺🌺",
//       },
//       { type: "FOOTER", text: "Team -eMedha" },
//       {
//         type: "BUTTONS",
//         buttons: [{ text: "Reach us", flowId: "", flowAction: "" }],
//       },
//     ],
//   },
//   { id: "2", name: "sudha_tom1", status: "APPROVED", category: "UTILITY", language: "en_US", components: [{ type: "BODY", text: "Hello {{1}}, your appointment is confirmed for {{2}}." }, { type: "FOOTER", text: "Team -eMedha" }] },
//   { id: "3", name: "sudha_tom", status: "APPROVED", category: "UTILITY", language: "hi", components: [{ type: "BODY", text: "नमस्ते {{1}}, आपकी अपॉइंटमेंट {{2}} के लिए निश्चित है।" }] },
//   { id: "4", name: "sudha_update1", status: "APPROVED", category: "MARKETING", language: "en_US", components: [{ type: "HEADER", format: "TEXT", text: "Important Update" }, { type: "BODY", text: "Dear {{1}}, we have an important update for you regarding your account." }, { type: "FOOTER", text: "eMedha Support" }] },
//   { id: "5", name: "sudha_tel", status: "APPROVED", category: "MARKETING", language: "te", components: [{ type: "BODY", text: "నమస్కారం {{1}}, మీ సందేశం అందింది." }] },
//   { id: "6", name: "appointment_reminder", status: "APPROVED", category: "UTILITY", language: "en_US", components: [{ type: "BODY", text: "Reminder: Your appointment is scheduled for {{1}} at {{2}}." }] },
//   { id: "7", name: "lab_result_alert", status: "PENDING", category: "UTILITY", language: "en_US", components: [{ type: "BODY", text: "Your lab results for {{1}} are ready. Please visit the clinic." }] },
//   { id: "8", name: "prescription_renew", status: "APPROVED", category: "UTILITY", language: "en_US", components: [{ type: "BODY", text: "Hi {{1}}, your prescription for {{2}} is due for renewal." }] },
//   { id: "9", name: "doctor_followup", status: "REJECTED", category: "MARKETING", language: "en_US", components: [{ type: "BODY", text: "Dr. {{1}} would like to schedule a follow-up with you." }] },
//   { id: "10", name: "welcome_patient", status: "APPROVED", category: "MARKETING", language: "en_US", components: [{ type: "HEADER", format: "TEXT", text: "Welcome!" }, { type: "BODY", text: "Welcome {{1}} to eMedha Health Services. We are glad to have you." }, { type: "FOOTER", text: "eMedha Team" }] },
// ];

// const PAGE_SIZE = 5;

// // Color maps reflecting standard web fallbacks
// const STATUS_STYLES = {
//   APPROVED: { backgroundColor: "#ecfdf5", color: "#047857", border: "1px solid #a7f3d0" },
//   PENDING: { backgroundColor: "#fffbeb", color: "#b45309", border: "1px solid #fde68a" },
//   REJECTED: { backgroundColor: "#fef2f2", color: "#b91c1c", border: "1px solid #fecaca" },
// };

// const THEME = {
//   border: "1px solid #e5e7eb",
//   cardBg: "#ffffff",
//   mutedBg: "#f9fafb",
//   textMain: "#1f2937",
//   textMuted: "#6b7280",
//   primary: "#3b82f6",
//   primaryLight: "#eff6ff",
// };

// // ─── Template Detail Panel ────────────────────────────────────────────────────

// function DetailPanel({ template, onClose }) {
//   const buttonComps = template.components.filter((c) => c.type === "BUTTONS");

//   return (
//     <div style={{ display: "flex", flexDirection: "column", height: "100%", backgroundColor: "#ffffff" }}>
//       {/* Panel header */}
//       <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderBottom: THEME.border, backgroundColor: THEME.cardBg, position: "sticky", top: 0, zIndex: 10 }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
//           <div style={{ width: "28px", height: "28px", borderRadius: "8px", backgroundColor: THEME.primaryLight, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//             <FileText size={14} style={{ color: THEME.primary }} />
//           </div>
//           <div style={{ minWidth: 0 }}>
//             <p style={{ margin: 0, fontSize: "10px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase", tracking: "wide" }}>Template Details</p>
//             <p style={{ margin: 0, fontSize: "14px", fontWeight: "bold", color: THEME.textMain, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
//               {template.name}
//             </p>
//           </div>
//         </div>
//         <button
//           onClick={onClose}
//           style={{ width: "32px", height: "32px", borderRadius: "8px", border: THEME.border, display: "flex", alignItems: "center", justifyContent: "center", color: THEME.textMuted, backgroundColor: "transparent", cursor: "pointer", transition: "all 0.2s" }}
//         >
//           <X size={15} />
//         </button>
//       </div>

//       <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>
//         {/* Properties table */}
//         <div style={{ backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, overflow: "hidden", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}>
//           <div style={{ padding: "10px 16px", backgroundColor: THEME.mutedBg, borderBottom: THEME.border, display: "flex", alignItems: "center", gap: "8px" }}>
//             <Tag size={13} style={{ color: THEME.primary }} />
//             <p style={{ margin: 0, fontSize: "12px", fontWeight: "bold", color: THEME.textMain, textTransform: "uppercase" }}>Properties</p>
//           </div>
//           <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
//             <thead>
//               <tr style={{ borderBottom: THEME.border, backgroundColor: "rgba(249, 250, 251, 0.5)" }}>
//                 <th style={{ textAlign: "left", padding: "10px 16px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase", width: "40%" }}>Property</th>
//                 <th style={{ textAlign: "left", padding: "10px 16px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Value</th>
//               </tr>
//             </thead>
//             <tbody>
//               {[
//                 { prop: "Category", val: template.category },
//                 { prop: "Sub Category", val: template.subCategory || "—" },
//                 { prop: "Status", val: <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: 500, ...STATUS_STYLES[template.status] }}>{template.status}</span> },
//                 { prop: "Language", val: template.language },
//               ].map(({ prop, val }) => (
//                 <tr key={prop} style={{ borderBottom: THEME.border }}>
//                   <td style={{ padding: "10px 16px", fontWeight: 600, color: THEME.textMain }}>{prop}</td>
//                   <td style={{ padding: "10px 16px", color: THEME.textMain }}>{val}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Components table */}
//         <div style={{ backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, overflow: "hidden", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}>
//           <div style={{ padding: "10px 16px", backgroundColor: THEME.mutedBg, borderBottom: THEME.border, display: "flex", alignItems: "center", gap: "8px" }}>
//             <Layers size={13} style={{ color: THEME.primary }} />
//             <p style={{ margin: 0, fontSize: "12px", fontWeight: "bold", color: THEME.textMain, textTransform: "uppercase" }}>Components</p>
//           </div>

//           <div style={{ overflowX: "auto" }}>
//             <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
//               <thead>
//                 <tr style={{ borderBottom: THEME.border, backgroundColor: "rgba(249, 250, 251, 0.5)" }}>
//                   {["Type", "Format", "Text"].map((h) => (
//                     <th key={h} style={{ textAlign: "left", padding: "10px 16px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase", whiteSpace: "nowrap" }}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {template.components.filter((c) => c.type !== "BUTTONS").map((comp, i) => (
//                   <tr key={i} style={{ borderBottom: THEME.border, verticalAlign: "top" }}>
//                     <td style={{ padding: "12px 16px", fontWeight: 600, color: THEME.textMain, whiteSpace: "nowrap" }}>
//                       <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: 600, backgroundColor: THEME.primaryLight, color: THEME.primary }}>
//                         {comp.type}
//                       </span>
//                     </td>
//                     <td style={{ padding: "12px 16px", color: THEME.textMuted }}>{comp.format ?? "—"}</td>
//                     <td style={{ padding: "12px 16px", color: THEME.textMain, lineHeight: "1.5" }}>
//                       {comp.text ? <span>{comp.text}</span> : "—"}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Buttons section */}
//         {buttonComps.length > 0 && buttonComps.map((bc, bi) =>
//           bc.buttons?.map((btn, i) => (
//             <div key={`${bi}-${i}`} style={{ backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, overflow: "hidden", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}>
//               <div style={{ padding: "10px 16px", backgroundColor: THEME.mutedBg, borderBottom: THEME.border, display: "flex", alignItems: "center", gap: "8px" }}>
//                 <MousePointerClick size={13} style={{ color: THEME.primary }} />
//                 <p style={{ margin: 0, fontSize: "12px", fontWeight: "bold", color: THEME.textMain, textTransform: "uppercase" }}>Button {i + 1}</p>
//               </div>
//               <div>
//                 {[
//                   { label: "Button Text", value: btn.text || "—" },
//                   { label: "Flow ID", value: btn.flowId || "—" },
//                   { label: "Flow Action", value: btn.flowAction || "—" },
//                 ].map(({ label, value }) => (
//                   <div key={label} style={{ display: "flex", alignItems: "flex-start", gap: "16px", padding: "10px 16px", borderBottom: THEME.border }}>
//                     <p style={{ margin: 0, fontSize: "12px", fontWeight: 600, color: THEME.textMuted, width: "112px", flexShrink: 0 }}>{label}</p>
//                     <p style={{ margin: 0, fontSize: "12px", color: THEME.textMain }}>{value}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }

// // ─── Templates Screen ─────────────────────────────────────────────────────────

// export default function Templates() {
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [selected, setSelected] = useState(null);

//   const filtered = TEMPLATES.filter((t) =>
//     t.name.toLowerCase().includes(search.toLowerCase())
//   );
//   const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
//   const paged = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

//   const handleSearch = (v) => { setSearch(v); setPage(1); };

//   const pageNums = (() => {
//     if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
//     if (page <= 4) return [1, 2, 3, 4, 5, "…", totalPages];
//     if (page >= totalPages - 3) return [1, "…", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
//     return [1, "…", page - 1, page, page + 1, "…", totalPages];
//   })();

//   return (
//     <div style={{ padding: "24px", fontFamily: "system-ui, -apple-system, sans-serif", backgroundColor: "#f3f4f6", minHeight: "100vh" }}>
//       {/* Stand-in for PageWrapper */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", flexWrap: "wrap", gap: "16px" }}>
//         <div>
//           <h1 style={{ margin: 0, fontSize: "24px", fontWeight: "bold", color: THEME.textMain, display: "flex", alignItems: "center", gap: "8px" }}>
//             <MessageSquare size={22} style={{ color: THEME.primary }} /> Message Templates
//           </h1>
//           <p style={{ margin: "4px 0 0 0", fontSize: "14px", color: THEME.textMuted }}>Manage and monitor your automated conversational templates</p>
//         </div>
//         <button style={{ display: "flex", alignItems: "center", gap: "6px", backgroundColor: THEME.primary, color: "#ffffff", border: "none", padding: "10px 16px", borderRadius: "8px", fontSize: "14px", fontWeight: 500, cursor: "pointer" }}>
//           <Plus size={16} /> New Template
//         </button>
//       </div>

//       {/* Two-pane responsive flex layout */}
//       <div style={{ display: "flex", gap: "20px", flexDirection: selected ? "row" : "column", flexWrap: "wrap", alignItems: "flex-start" }}>

//         {/* Table Pane */}
//         <div style={{ flex: selected ? "1 1 500px" : "1 1 100%", minWidth: 0, width: "100%" }}>
//           <div style={{ backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, boxShadow: "0 1px 3px rgba(0,0,0,0.1)", overflow: "hidden" }}>

//             {/* Table Toolbar */}
//             <div style={{ padding: "14px 20px", borderBottom: THEME.border, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
//               <p style={{ margin: 0, fontSize: "12px", color: THEME.textMuted }}>
//                 Showing <span style={{ fontWeight: 600, color: THEME.textMain }}>{filtered.length === 0 ? 0 : (page - 1) * PAGE_SIZE + 1}</span> to{" "}
//                 <span style={{ fontWeight: 600, color: THEME.textMain }}>{Math.min(page * PAGE_SIZE, filtered.length)}</span> of{" "}
//                 <span style={{ fontWeight: 600, color: THEME.textMain }}>{filtered.length}</span> templates
//               </p>
//               <div style={{ position: "relative", width: "220px" }}>
//                 <Search size={13} style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.textMuted }} />
//                 <input
//                   value={search}
//                   onChange={(e) => handleSearch(e.target.value)}
//                   placeholder="Search template name..."
//                   style={{ width: "100%", boxSizing: "border-box", padding: "8px 12px 8px 32px", fontSize: "12px", borderRadius: "8px", border: THEME.border, outline: "none", backgroundColor: "#f9fafb" }}
//                 />
//               </div>
//             </div>

//             {/* Desktop Table view */}
//             <div style={{ overflowX: "auto" }}>
//               <table style={{ width: "100%", fontSize: "14px", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ borderBottom: THEME.border, backgroundColor: "rgba(249, 250, 251, 0.6)" }}>
//                     <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Template Name</th>
//                     <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Status</th>
//                     <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paged.map((t) => {
//                     const isSelected = selected?.id === t.id;
//                     return (
//                       <tr key={t.id} style={{ borderBottom: THEME.border, backgroundColor: isSelected ? "rgba(59, 130, 246, 0.05)" : "transparent" }}>
//                         <td style={{ padding: "14px 20px" }}>
//                           <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                             <div style={{ width: "24px", height: "24px", borderRadius: "6px", backgroundColor: THEME.primaryLight, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                               <MessageSquare size={11} style={{ color: THEME.primary }} />
//                             </div>
//                             <span style={{ fontSize: "12px", fontWeight: 600, color: THEME.textMain, fontFamily: "monospace" }}>{t.name}</span>
//                           </div>
//                         </td>
//                         <td style={{ padding: "14px 20px" }}>
//                           <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: 500, ...STATUS_STYLES[t.status] }}>
//                             {t.status === "APPROVED" && <CheckCircle size={10} />}
//                             {t.status}
//                           </span>
//                         </td>
//                         <td style={{ padding: "14px 20px" }}>
//                           <button
//                             onClick={() => setSelected(isSelected ? null : t)}
//                             style={{
//                               width: "28px", height: "28px", borderRadius: "8px", border: isSelected ? `1px solid ${THEME.primary}` : THEME.border,
//                               backgroundColor: isSelected ? THEME.primary : "transparent", color: isSelected ? "#ffffff" : THEME.textMuted,
//                               display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer"
//                             }}
//                           >
//                             <Eye size={13} />
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                   {paged.length === 0 && (
//                     <tr>
//                       <td colSpan={3} style={{ padding: "40px", textAlign: "center", fontSize: "12px", color: THEME.textMuted }}>No templates found.</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination Row */}
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 20px", borderTop: THEME.border, flexWrap: "wrap", gap: "12px" }}>
//               <button
//                 onClick={() => setPage((p) => Math.max(1, p - 1))}
//                 disabled={page === 1}
//                 style={{ display: "flex", alignItems: "center", gap: "4px", padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: 500, color: THEME.textMuted, border: THEME.border, backgroundColor: "#ffffff", cursor: page === 1 ? "not-allowed" : "pointer", opacity: page === 1 ? 0.4 : 1 }}
//               >
//                 <ChevronLeft size={12} /> Previous
//               </button>

//               <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                 {pageNums.map((n, i) =>
//                   n === "…" ? (
//                     <span key={`ellipsis-${i}`} style={{ padding: "0 8px", fontSize: "12px", color: THEME.textMuted }}>…</span>
//                   ) : (
//                     <button
//                       key={n}
//                       onClick={() => setPage(n)}
//                       style={{
//                         width: "28px", height: "28px", borderRadius: "8px", fontSize: "12px", fontWeight: 500, border: page === n ? "none" : THEME.border,
//                         backgroundColor: page === n ? THEME.primary : "#ffffff", color: page === n ? "#ffffff" : THEME.textMuted, cursor: "pointer"
//                       }}
//                     >
//                       {n}
//                     </button>
//                   )
//                 )}
//               </div>

//               <button
//                 onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//                 disabled={page === totalPages || totalPages === 0}
//                 style={{ display: "flex", alignItems: "center", gap: "4px", padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: 500, color: THEME.textMuted, border: THEME.border, backgroundColor: "#ffffff", cursor: (page === totalPages || totalPages === 0) ? "not-allowed" : "pointer", opacity: (page === totalPages || totalPages === 0) ? 0.4 : 1 }}
//               >
//                 Next <ChevronRight size={12} />
//               </button>
//             </div>

//           </div>
//         </div>

//         {/* Detail Pane */}
//         {selected && (
//           <div style={{ flex: "1 1 400px", minWidth: 0, width: "100%", backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, boxShadow: "0 1px 3px rgba(0,0,0,0.1)", overflow: "hidden" }}>
//             <DetailPanel template={selected} onClose={() => setSelected(null)} />
//           </div>
//         )}

//       </div>
//     </div>
//   );
// }



import React, { useState, useEffect } from "react";
import {
  MessageSquare, Search, Eye, X, ChevronLeft, ChevronRight,
  FileText, CheckCircle, Tag, Layers
} from "lucide-react";

// ─── Theme Configurations ──────────────────────────────────────────────────
const THEME = {
  border: "1px solid #e5e7eb",
  cardBg: "#ffffff",
  mutedBg: "#f9fafb",
  textMain: "#1f2937",
  textMuted: "#6b7280",
  primary: "#2563eb",
  primaryLight: "#eff6ff",
};

const STATUS_STYLES = {
  APPROVED: { backgroundColor: "#e6f4ea", color: "#137333", border: "1px solid #a7f3d0" },
  approve: { backgroundColor: "#e6f4ea", color: "#137333", border: "1px solid #a7f3d0" },
  PENDING: { backgroundColor: "#fffbeb", color: "#b45309", border: "1px solid #fde68a" },
  REJECTED: { backgroundColor: "#fce8e6", color: "#c5221f", border: "1px solid #fecaca" },
};

// ─── Component: DetailPanel (Refactored View Screen) ───────────────────────
function DetailPanel({ templateDetails, onClose }) {
  if (!templateDetails) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", backgroundColor: "#ffffff" }}>
      {/* Panel Header */}
      <div style={{ display: "flex", alignItems: "center", justifyindex: "space-between", justifyContent: "space-between", padding: "16px 20px", borderBottom: THEME.border, backgroundColor: THEME.cardBg, position: "sticky", top: 0, zIndex: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: 0 }}>
          <div style={{ width: "28px", height: "28px", borderRadius: "8px", backgroundColor: THEME.primaryLight, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <FileText size={14} style={{ color: THEME.primary }} />
          </div>
          <div style={{ minWidth: 0 }}>
            <p style={{ margin: 0, fontSize: "10px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase", tracking: "wide" }}>Template Details</p>
            <p style={{ margin: 0, fontSize: "14px", fontWeight: "bold", color: THEME.textMain, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {templateDetails.name}
            </p>
          </div>
        </div>
        <button
          onClick={onClose}
          style={{ width: "32px", height: "32px", borderRadius: "8px", border: THEME.border, display: "flex", alignItems: "center", justifyContent: "center", color: THEME.textMuted, backgroundColor: "transparent", cursor: "pointer" }}
        >
          <X size={15} />
        </button>
      </div>

      <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "16px" }}>
        {/* Core Properties Matrix */}
        <div style={{ backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, overflow: "hidden", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}>
          <div style={{ padding: "10px 16px", backgroundColor: THEME.mutedBg, borderBottom: THEME.border, display: "flex", alignItems: "center", gap: "8px" }}>
            <Tag size={13} style={{ color: THEME.primary }} />
            <p style={{ margin: 0, fontSize: "12px", fontWeight: "bold", color: THEME.textMain, textTransform: "uppercase" }}>Properties</p>
          </div>
          <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: THEME.border, backgroundColor: "rgba(249, 250, 251, 0.5)" }}>
                <th style={{ textAlign: "left", padding: "10px 16px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase", width: "40%" }}>Property</th>
                <th style={{ textAlign: "left", padding: "10px 16px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {[
                { prop: "Category", val: templateDetails.category },
                { prop: "Sub Category", val: templateDetails.sub_category || "—" },
                {
                  prop: "Status",
                  val: (
                    <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: 500, ...(STATUS_STYLES[templateDetails.status] || { backgroundColor: "#f3f4f6", color: "#374151" }) }}>
                      {templateDetails.status}
                    </span>
                  )
                },
                { prop: "Language", val: templateDetails.language },
              ].map(({ prop, val }) => (
                <tr key={prop} style={{ borderBottom: THEME.border }}>
                  <td style={{ padding: "10px 16px", fontWeight: 600, color: THEME.textMain }}>{prop}</td>
                  <td style={{ padding: "10px 16px", color: THEME.textMain }}>{val}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Structural Message Components */}
        <div style={{ backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, overflow: "hidden", boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)" }}>
          <div style={{ padding: "10px 16px", backgroundColor: THEME.mutedBg, borderBottom: THEME.border, display: "flex", alignItems: "center", gap: "8px" }}>
            <Layers size={13} style={{ color: THEME.primary }} />
            <p style={{ margin: 0, fontSize: "12px", fontWeight: "bold", color: THEME.textMain, textTransform: "uppercase" }}>Components</p>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: THEME.border, backgroundColor: "rgba(249, 250, 251, 0.5)" }}>
                  {["Type", "Format", "Content Assets"].map((h) => (
                    <th key={h} style={{ textAlign: "left", padding: "10px 16px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {templateDetails.components && templateDetails.components.length > 0 ? (
                  templateDetails.components.map((component, idx) => (
                    <tr key={idx} style={{ borderBottom: THEME.border, verticalAlign: "top" }}>
                      <td style={{ padding: "12px 16px", fontWeight: 600, color: THEME.textMain, whiteSpace: "nowrap" }}>
                        <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: 600, backgroundColor: THEME.primaryLight, color: THEME.primary }}>
                          {component.type}
                        </span>
                      </td>
                      <td style={{ padding: "12px 16px", color: THEME.textMuted }}>{component.format ?? "—"}</td>
                      <td style={{ padding: "12px 16px", color: THEME.textMain, lineHeight: "1.5" }}>
                        {component.text && <div style={{ marginBottom: "8px", wordBreak: "break-word" }}>{component.text}</div>}

                        {/* Inline Rich Media Render Engines */}
                        {component.example && component.example.header_handle && component.example.header_handle.length > 0 && (
                          <div style={{ marginTop: "8px" }}>
                            {(() => {
                              const mediaUrl = component.example.header_handle[0];
                              const formatType = component.format?.toUpperCase();

                              switch (formatType) {
                                case "IMAGE":
                                  return <img src={mediaUrl} alt="Header Example" style={{ maxWidth: "150px", height: "auto", borderRadius: "6px", border: THEME.border }} />;
                                case "VIDEO":
                                  return (
                                    <video width="200" height="auto" controls style={{ borderRadius: "6px" }}>
                                      <source src={mediaUrl} type="video/mp4" />
                                      Your browser does not support video.
                                    </video>
                                  );
                                case "DOCUMENT":
                                  return (
                                    <a href={mediaUrl} target="_blank" rel="noopener noreferrer" style={{ color: THEME.primary, fontWeight: 500, textDecoration: "none" }}>
                                      View PDF Document
                                    </a>
                                  );
                                case "LOCATION":
                                  const [lat, lng] = mediaUrl.split(",");
                                  return (
                                    <iframe
                                      title="Location Visualizer"
                                      src={`https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
                                      width="100%"
                                      height="120"
                                      style={{ border: 0, borderRadius: "6px" }}
                                      loading="lazy"
                                    ></iframe>
                                  );
                                default:
                                  return <span style={{ color: THEME.textMuted }}>Unsupported Asset ({formatType})</span>;
                              }
                            })()}
                          </div>
                        )}

                        {/* Interactive UI Action Nodes */}
                        {component.buttons && component.buttons.length > 0 && (
                          <div style={{ marginTop: "10px", padding: "10px", backgroundColor: THEME.mutedBg, borderRadius: "6px", border: THEME.border }}>
                            <p style={{ margin: "0 0 6px 0", fontSize: "11px", fontWeight: "bold", color: THEME.textMuted }}>BUTTON CONFIGURATIONS:</p>
                            <ul style={{ margin: 0, paddingLeft: "16px", fontSize: "11px" }}>
                              {component.buttons.map((btn, bIdx) => (
                                <li key={bIdx} style={{ marginBottom: "6px" }}>
                                  <strong>Label:</strong> {btn.text || "—"} | <strong>Flow:</strong> {btn.flow_id || "—"} | <strong>Action:</strong> {btn.flow_action || "—"}
                                  {btn.navigate_screen && <span> | <strong>Screen:</strong> {btn.navigate_screen}</span>}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ padding: "16px", textAlign: "center", color: THEME.textMuted }}>No sub-components mapped.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
}

// ─── Main Controller Component: MessageTemplates ───────────────────────────
export default function MessageTemplates() {
  const [templates, setTemplates] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [wid, setWid] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const templatesPerPage = 10;

  // Lifecycle: Resolve Global Web Identity Credentials
  useEffect(() => {
    const sessionUser = sessionStorage.getItem("user");
    if (!sessionUser) return;

    try {
      const user = JSON.parse(sessionUser);
      const emailToUse = user.role === "admin" ? user.email : user.adminEmail;
      if (!emailToUse) return;

      fetch(`https://botapi.emedha.in/pages/api/get-user-data?email=${encodeURIComponent(emailToUse)}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.wa_id) setWid(data.wa_id);
        })
        .catch((err) => console.error("Error fetching identifier metadata:", err));
    } catch (e) {
      console.error("Session configuration corrupted:", e);
    }
  }, []);

  // Lifecycle: Sync Remote Template Registries
  useEffect(() => {
    if (wid) fetchTemplates(wid);
  }, [wid]);

  const fetchTemplates = async (waId) => {
    try {
      const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateStatus.php?limit=100&wid=${waId}`);
      const data = await response.json();
      if (data && data.data) {
        const cleanArray = Array.isArray(data.data) ? data.data : Object.values(data.data);
        setTemplates(cleanArray);
      }
    } catch (error) {
      console.error("Pipeline failure fetching template listings:", error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleViewTemplateDetails = async (templateName) => {
    if (selectedTemplate && selectedTemplate.name === templateName) {
      setSelectedTemplate(null);
      return;
    }

    setLoadingDetails(true);
    try {
      const response = await fetch(`https://emedha.com/echatbot/enotifier/getTemplateInfo.php?name=${templateName}&wid=${wid}`);
      const data = await response.json();
      if (data && data.data && data.data.length > 0) {
        setSelectedTemplate(data.data[0]);
      } else {
        console.warn("Null records dispatched for queried model specifications.");
      }
    } catch (error) {
      console.error("Error executing component detail expansion:", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  // Processing: Filter and Partition Core Record Data
  const filteredTemplates = templates.filter((t) =>
    t && t.name && t.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalEntries = filteredTemplates.length;
  const indexOfLastTemplate = currentPage * templatesPerPage;
  const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
  const currentTemplates = filteredTemplates.slice(indexOfFirstTemplate, indexOfLastTemplate);

  const displayStart = totalEntries > 0 ? indexOfFirstTemplate + 1 : 0;
  const displayEnd = Math.min(indexOfLastTemplate, totalEntries);
  const totalPages = Math.ceil(totalEntries / templatesPerPage);

  // Pagination Truncation Engine
  const getPaginationRange = () => {
    const totalNumbers = 5;
    const siblings = 1;

    if (totalPages <= totalNumbers + 2) {
      return [...Array(totalPages).keys()].map((i) => i + 1);
    }

    const leftSiblingIndex = Math.max(currentPage - siblings, 1);
    const rightSiblingIndex = Math.min(currentPage + siblings, totalPages);
    const showLeftEllipsis = leftSiblingIndex > 2;
    const showRightEllipsis = rightSiblingIndex < totalPages - 1;

    if (!showLeftEllipsis && showRightEllipsis) {
      let leftItemCount = 3 + 2 * siblings;
      return [...[...Array(leftItemCount).keys()].map((i) => i + 1), "…", totalPages];
    }

    if (showLeftEllipsis && !showRightEllipsis) {
      let rightItemCount = 3 + 2 * siblings;
      let rightRange = [...Array(rightItemCount).keys()].map((i) => totalPages - rightItemCount + i + 1);
      return [1, "…", ...rightRange];
    }

    if (showLeftEllipsis && showRightEllipsis) {
      let middleRange = [];
      for (let i = leftSiblingIndex; i <= rightSiblingIndex; i++) {
        middleRange.push(i);
      }
      return [1, "…", ...middleRange, "…", totalPages];
    }
    return [];
  };

  return (
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif", minHeight: "100vh" }}>

      {/* Control Title Bar */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", flexWrap: "wrap", gap: "16px" }}>
        <div>
          <h1 style={{ margin: 0, fontSize: "24px", fontWeight: "bold", color: THEME.textMain, display: "flex", alignItems: "center", gap: "8px" }}>
            <MessageSquare size={22} style={{ color: THEME.primary }} /> Approved Templates
          </h1>
          {/* <p style={{ margin: "4px 0 0 0", fontSize: "14px", color: THEME.textMuted }}>Manage and monitor your automated conversational templates</p> */}
        </div>
      </div>

      {/* Two-Pane Workspace Layout Engine */}
      <div style={{ display: "flex", gap: "20px", flexDirection: selectedTemplate ? "row" : "column", flexWrap: "wrap", alignItems: "flex-start" }}>

        {/* Left Grid Pane */}
        {!selectedTemplate && (
          <div style={{ flex: selectedTemplate ? "1 1 500px" : "1 1 100%", minWidth: 0, width: "100%" }}>
            <div style={{ backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, boxShadow: "0 1px 3px rgba(0,0,0,0.1)", overflow: "hidden" }}>

              {/* Contextual Sub-Header Toolkit */}
              <div style={{ padding: "14px 20px", borderBottom: THEME.border, display: "flex", justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
                <div style={{ position: "relative", width: "240px" }}>
                  <Search size={13} style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: THEME.textMuted }} />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="Search template name..."
                    style={{ width: "100%", boxSizing: "border-box", padding: "8px 12px 8px 32px", fontSize: "13px", borderRadius: "8px", border: THEME.border, outline: "none", backgroundColor: "#f9fafb" }}
                  />
                </div>
              </div>

              {/* Core Data Presentation Matrix */}
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", fontSize: "14px", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ borderBottom: THEME.border, backgroundColor: "rgba(249, 250, 251, 0.6)" }}>
                      <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Template Name</th>
                      <th style={{ textAlign: "left", padding: "12px 20px", fontSize: "11px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Status</th>
                      <th style={{ textAlign: "right", padding: "12px 20px", fontSize: "11px", fontWeight: 600, color: THEME.textMuted, textTransform: "uppercase" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentTemplates.map((template, idx) => {
                      const isSelected = selectedTemplate?.name === template.name;
                      return (
                        <tr key={template.id || idx} style={{ borderBottom: THEME.border, backgroundColor: isSelected ? "rgba(37, 99, 235, 0.05)" : "transparent" }}>
                          <td style={{ padding: "14px 20px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <div style={{ width: "24px", height: "24px", borderRadius: "6px", backgroundColor: THEME.primaryLight, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <MessageSquare size={11} style={{ color: THEME.primary }} />
                              </div>
                              <span style={{ fontSize: "12px", fontWeight: 600, color: THEME.textMain, fontFamily: "monospace" }}>{template?.name || "Unnamed"}</span>
                            </div>
                          </td>
                          <td style={{ padding: "14px 20px" }}>
                            <span style={{ display: "inline-flex", alignItems: "center", padding: "2px 8px", borderRadius: "9999px", fontSize: "11px", fontWeight: 500, ...(STATUS_STYLES[template?.status] || { backgroundColor: "#f3f4f6", color: "#374151" }) }}>
                              {template?.status === "APPROVED" && <CheckCircle size={10} style={{ marginRight: "4px" }} />}
                              {template?.status || "UNKNOWN"}
                            </span>
                          </td>
                          <td style={{ padding: "14px 20px", textAlign: "right" }}>
                            <button
                              onClick={() => handleViewTemplateDetails(template.name)}
                              disabled={loadingDetails}
                              style={{
                                width: "28px", height: "28px", borderRadius: "8px", border: isSelected ? `1px solid ${THEME.primary}` : THEME.border,
                                backgroundColor: isSelected ? THEME.primary : "transparent", color: isSelected ? "#ffffff" : THEME.textMuted,
                                display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer"
                              }}
                              title="View Details"
                            >
                              <Eye size={13} />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    {currentTemplates.length === 0 && (
                      <tr>
                        <td colSpan={3} style={{ padding: "40px", textAlign: "center", fontSize: "12px", color: THEME.textMuted }}>
                          No templates found matching your criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination Controls & Contextual Information Footer */}
              {totalPages > 1 && (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", padding: "16px 20px", borderTop: THEME.border }}>
                  {/* Controls Actions Sub-bar */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", flexWrap: "wrap", gap: "12px" }}>
                    <button
                      onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                      disabled={currentPage === 1}
                      style={{ display: "flex", alignItems: "center", gap: "4px", padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: 500, color: THEME.textMuted, border: THEME.border, backgroundColor: "#ffffff", cursor: currentPage === 1 ? "not-allowed" : "pointer", opacity: currentPage === 1 ? 0.4 : 1 }}
                    >
                      <ChevronLeft size={12} /> Previous
                    </button>

                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      {getPaginationRange().map((pageNumber, index) =>
                        pageNumber === "…" ? (
                          <span key={`ellipsis-${index}`} style={{ padding: "0 8px", fontSize: "12px", color: THEME.textMuted }}>…</span>
                        ) : (
                          <button
                            key={pageNumber}
                            onClick={() => setCurrentPage(pageNumber)}
                            style={{
                              width: "28px", height: "28px", borderRadius: "8px", fontSize: "12px", fontWeight: 500, border: currentPage === pageNumber ? "none" : THEME.border,
                              backgroundColor: currentPage === pageNumber ? THEME.primary : "#ffffff", color: currentPage === pageNumber ? "#ffffff" : THEME.textMuted, cursor: "pointer"
                            }}
                          >
                            {pageNumber}
                          </button>
                        )
                      )}
                    </div>

                    <button
                      onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                      disabled={currentPage === totalPages}
                      style={{ display: "flex", alignItems: "center", gap: "4px", padding: "6px 12px", borderRadius: "8px", fontSize: "12px", fontWeight: 500, color: THEME.textMuted, border: THEME.border, backgroundColor: "#ffffff", cursor: currentPage === totalPages ? "not-allowed" : "pointer", opacity: currentPage === totalPages ? 0.4 : 1 }}
                    >
                      Next <ChevronRight size={12} />
                    </button>
                  </div>

                  {/* Showing info line cleanly structured below pagination controls */}
                  <div style={{ width: "100%", textAlign: "center", borderTop: "1px dashed #f3f4f6", paddingTop: "12px" }}>
                    <p style={{ margin: 0, fontSize: "13px", color: THEME.textMuted }}>
                      Showing <span style={{ fontWeight: 600, color: THEME.textMain }}>{displayStart}</span> to <span style={{ fontWeight: 600, color: THEME.textMain }}>{displayEnd}</span> of <span style={{ fontWeight: 600, color: THEME.textMain }}>{totalEntries}</span> templates
                    </p>
                  </div>
                </div>
              )}

            </div>
          </div>
        )}

        {/* Right Detail Inspection Pane */}
        {selectedTemplate && (
          <div style={{ flex: "1 1 440px", minWidth: 0, width: "100%", backgroundColor: THEME.cardBg, borderRadius: "12px", border: THEME.border, boxShadow: "0 1px 3px rgba(0,0,0,0.1)", overflow: "hidden", position: "sticky", top: "24px" }}>
            <DetailPanel templateDetails={selectedTemplate} onClose={() => setSelectedTemplate(null)} />
          </div>
        )}

      </div>
    </div>
  );
}